// @ts-strict-ignore
import ReactRailsUJS from "react_ujs";

import { isModernBrowser } from "@shared/polyfill/isModernBrowser/isModernBrowser";
import {
  POLYFILL_SRCS,
  loadPolyfillSrcs,
} from "@shared/polyfill/loadPolyfillSrcs/loadPolyfillSrcs";

ReactRailsUJS.mountComponentsOriginal = ReactRailsUJS.mountComponents;
/* eslint-disable prefer-arrow-functions/prefer-arrow-functions */
ReactRailsUJS.mountComponents = function (...args) {
  const srcs = window[POLYFILL_SRCS];

  if (!isModernBrowser()) {
    loadPolyfillSrcs(srcs, () => {
      ReactRailsUJS.mountComponentsOriginal(...args);
    });
  } else {
    ReactRailsUJS.mountComponentsOriginal(...args);
  }
};

export default ReactRailsUJS;
